import classNames from 'classnames';
import { Toggle as RadixToggle } from 'radix-ui';
import type { ComponentPropsWithoutRef } from 'react';
import * as styles from './index.css';

export type ToggleButtonProps = ComponentPropsWithoutRef<typeof RadixToggle.Root>;

export function ToggleButton({ className, ...props }: ToggleButtonProps) {
    return <RadixToggle.Root className={classNames(styles.root, className)} {...props} />;
}
